<template>
  <ol :class="listClassName">
    <li
      :class="listItemClassName"
      v-for="item in items"
      :key="item.option_id"
    >
      <CheckBlock
        v-if="!hasImage"
        :value="value.some(v => v.option_id === item.option_id)"
        @input="onInput($event, item.option_id)"
        :single="single"
      >
        <div class="u-pre-wrap">{{ $domUtils.decode(item.option_text) }}</div>
      </CheckBlock>

      <CheckImage
        v-if="hasImage"
        :src="item.option_image"
        :value="value.some(v => v.option_id === item.option_id)"
        @input="onInput($event, item.option_id)"
        :single="single"
      >
        <div class="u-pre-wrap">{{ $domUtils.decode(item.option_text) }}</div>
      </CheckImage>
    </li>
  </ol>
</template>

<script>
import CheckBlock from '@/components/CheckBlock.vue'
import CheckImage from '@/components/CheckImage.vue'

export default {
  props: {
    hasImage: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    single: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    CheckBlock,
    CheckImage
  },

  computed: {
    listClassName() {
      return this.hasImage
        ? ['checkimage-list']
        : ['checkblock-list']
    },
    listItemClassName() {
      return `${this.listClassName[0]}-item`
    }
  },

  methods: {
    onInput(checked, key) {
      // 単一選択
      if (this.single) {
        this.$emit('input', checked ? [{ option_id: key }] : [])
        return false
      }

      // 複数選択
      const val = checked
        ? [...this.value, { option_id: key }]
        : this.value.filter(v => v.option_id !== key)

      this.$emit('input', val)
    }
  }
}
</script>
